/**
 * Used to tell a component that allows absolute positioning where on the screen to display itself.
 */
export const ScreenPosition = {
  TopLeft: 0,
  Left: 1,
  BottomLeft: 2,
  Top: 3,
  Center: 4,
  Bottom: 5,
  TopRight: 6,
  Right: 7,
  BottomRight: 8,
} as const;
export type ScreenPosition = (typeof ScreenPosition)[keyof typeof ScreenPosition];

export const DomTargetPosition = {
  TopLeft: 0,
  TopRight: 1,
  BottomLeft: 2,
  BottomRight: 3,
  Left: 4,
  Right: 5,
} as const;
export type DomTargetPosition = (typeof DomTargetPosition)[keyof typeof DomTargetPosition];

export const DomElementAlignment = {
  TopLeft: 0,
  TopRight: 1,
  BottomLeft: 2,
  BottomRight: 3,
} as const;
export type DomElementAlignment = (typeof DomElementAlignment)[keyof typeof DomElementAlignment];

export const ModalDialogDefaultButtonSettings = {
  OkCancel: 0,
  YesNo: 1,
  Custom: 2,
} as const;
export type ModalDialogDefaultButtonSettings =
  (typeof ModalDialogDefaultButtonSettings)[keyof typeof ModalDialogDefaultButtonSettings];

export const ModalDialogDockLocation = {
  Top: 0,
  Bottom: 1,
  Left: 2,
  Right: 3,
} as const;
export type ModalDialogDockLocation = (typeof ModalDialogDockLocation)[keyof typeof ModalDialogDockLocation];

export const ModalDialogButtonReturnType = {
  OK: 0,
  Cancel: 1,
  Yes: 2,
  No: 3,
  Custom: 4,
} as const;
export type ModalDialogButtonReturnType =
  (typeof ModalDialogButtonReturnType)[keyof typeof ModalDialogButtonReturnType];

export const DataSearchLocation = {
  Local: 0,
  Api: 1,
} as const;
export type DataSearchLocation = (typeof DataSearchLocation)[keyof typeof DataSearchLocation];
